import {
  animate,
  AnimationEvent,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
} from '@angular/core';

type TooltipVisibility = 'enter' | 'leave';

@Component({
  selector: 'app-tooltip-content',
  templateUrl: './tooltip-content.component.html',
  styleUrls: ['./tooltip-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('state', [
      state('void, leave', style({ opacity: 0, transform: 'scale(0.8)' })),
      state('enter', style({ opacity: 1, transform: 'scale(1)' })),
      transition('* => enter', animate('150ms cubic-bezier(0, 0, 0.2, 1)')),
      transition('* => leave', animate('75ms cubic-bezier(0.4, 0, 1, 1)')),
    ]),
  ],
  host: {
    class: 'app-tooltip',
    'aria-hidden': 'true',
    '[@state]': 'visibility',
    '(@state.done)': 'onAnimationDone($event)',
  },
})
export class TooltipContentComponent {
  message = '';
  visibility: TooltipVisibility = 'enter';
  readonly afterLeave = new EventEmitter<void>();

  constructor(private readonly cdr: ChangeDetectorRef) {}

  show(): void {
    this.visibility = 'enter';
    this.cdr.markForCheck();
  }

  startLeave(): void {
    this.visibility = 'leave';
    this.cdr.markForCheck();
  }

  onAnimationDone(event: AnimationEvent): void {
    // Guard against a re-hover that interrupted the leave animation: the
    // cancelled player still fires done with toState 'leave', but visibility
    // is already 'enter' — ignore it so the tooltip is not detached.
    if (event.toState === 'leave' && this.visibility === 'leave') {
      this.afterLeave.emit();
    }
  }
}
